<div
  class="chat-drop-zone"
  appDnd
  (fileDropped)="onFilesDropped($event)"
  (hover)="isDragging = $event"
>
  <!-- Drag overlay -->
  <div class="drag-overlay" *ngIf="isDragging">
    <div class="drag-overlay-content">
      <nw-icon type="upload_file" [size]="48" color="#6366f1"></nw-icon>
      <div>Drop files here</div>
    </div>
  </div>

  <!-- Hidden file input -->
  <input
    #fileInput
    type="file"
    accept="image/*,video/*,.pdf,.ppt,.pptx,.doc,.docx,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    multiple
    hidden
    (change)="onFilesSelected($event)"
  />

  <!-- Discussion loading -->
  <div class="discussion-loading" *ngIf="isDiscussionLoading$ | async">
    Discussion is being loaded...
  </div>

  <!-- Initial prompt view (no messages yet) -->
  <div
    class="chat-container flex-column"
    *ngIf="!(isDiscussionLoading$ | async) && (messages$ | async)?.length === 0"
  >
    <div class="chat-greeting">What would you like to create?</div>
    <div class="chat-initial-card">
      <div class="flex-column gap-8 input-field">
        <textarea
          [(ngModel)]="inputValue"
          rows="4"
          placeholder="Describe your video idea..."
          (keydown)="onKeydown($event)"
        ></textarea>

        <div class="thumbnails" *ngIf="pendingFiles.length > 0">
          <div class="thumb" *ngFor="let item of pendingFiles; let i = index">
            <button
              type="button"
              class="remove-btn"
              (click)="removePendingFile(i, $event)"
            >
              &times;
            </button>
            <nw-file-preview
              [meta]="item.meta"
              [previewUrl]="item.preview?.objectUrl"
            ></nw-file-preview>
          </div>
        </div>

        <div class="flex-row space-between fs-12 input-row">
          <div class="flex-row gap-8">
            <div class="icon-cont" (click)="triggerFileInput()">
              <nw-icon type="upload" [size]="16" [outlined]="true"></nw-icon>
              <div>Video, image, file</div>
            </div>
          </div>
          <div
            class="send-circle"
            [style.opacity]="
              (!inputValue.trim() && !pendingFiles.length) ||
              (isResponseLoading$ | async)
                ? 0.4
                : 1
            "
            [style.pointer-events]="
              (!inputValue.trim() && !pendingFiles.length) ||
              (isResponseLoading$ | async)
                ? 'none'
                : 'auto'
            "
          >
            <nw-icon
              type="arrow_upward_alt"
              [size]="16"
              (click)="send()"
            ></nw-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Conversation view (has messages) -->
  <div class="chat-conversation" *ngIf="(messages$ | async)?.length > 0">
    <div class="chat-messages" #messageList>
      <div
        class="chat-message"
        *ngFor="let msg of messages$ | async"
        [class.user]="msg.role === 'user'"
        [class.assistant]="msg.role === 'assistant'"
      >
        <div class="message-bubble">
          <!-- Files -->
          <div class="message-attachments" *ngIf="msg.files?.length">
            <nw-file-preview
              *ngFor="let file of msg.files"
              [meta]="file"
              [previewUrl]="getPreviewUrl(file)"
            ></nw-file-preview>
          </div>
          <!-- Text -->
          <div *ngIf="msg.content">{{ msg.content }}</div>
        </div>
      </div>

      <div class="chat-loading" *ngIf="isResponseLoading$ | async">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>

    <div class="chat-error" *ngIf="error$ | async as error">
      {{ error }}
    </div>

    <div class="chat-input-bar">
      <div class="flex-column gap-8 input-field">
        <textarea
          [(ngModel)]="inputValue"
          (keydown)="onKeydown($event)"
          placeholder="Type a message..."
          rows="2"
        ></textarea>

        <div class="thumbnails" *ngIf="pendingFiles.length > 0">
          <div class="thumb" *ngFor="let item of pendingFiles; let i = index">
            <button
              type="button"
              class="remove-btn"
              (click)="removePendingFile(i, $event)"
            >
              &times;
            </button>
            <nw-file-preview
              [meta]="item.meta"
              [previewUrl]="item.preview?.objectUrl"
            ></nw-file-preview>
          </div>
        </div>

        <div class="flex-row space-between fs-12 input-row">
          <div class="flex-row gap-8">
            <div class="icon-cont" (click)="triggerFileInput()">
              <nw-icon type="upload" [size]="16" [outlined]="true"></nw-icon>
              <div>Video, image, file</div>
            </div>
          </div>
          <div
            class="send-circle"
            [style.opacity]="
              (!inputValue.trim() && !pendingFiles.length) ||
              (isResponseLoading$ | async)
                ? 0.4
                : 1
            "
            [style.pointer-events]="
              (!inputValue.trim() && !pendingFiles.length) ||
              (isResponseLoading$ | async)
                ? 'none'
                : 'auto'
            "
          >
            <nw-icon
              type="arrow_upward_alt"
              [size]="16"
              (click)="send()"
            ></nw-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
